module.exports = __webpack_public_path__ + "static/media/point-of-view.cc2749a1.png";